import { Star } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="itoto-login">
      <div className="itoto-box">
        <div className="itoto-logo">
          <div className="word">
            <span>i</span><span>T</span>
            <span className="star-o"><Star size={26} strokeWidth={2.4} style={{ color: "#9b6cff" }} /></span>
            <span>T</span><span>O</span>
          </div>
          <div className="whitelabel">Whitelabel</div>
        </div>
        <form onSubmit={submit}>
          {error && <div className="itoto-error" data-testid="login-error">{error}</div>}
          <div className="itoto-field">
            <label>USERNAME</label><span className="colon">:</span>
            <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div className="itoto-field">
            <label>PASSWORD</label><span className="colon">:</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <button type="submit" className="itoto-login-btn" disabled={loading} data-testid="login-submit">
            {loading ? "..." : "LOGIN"}
          </button>
        </form>
      </div>
    </div>
  );
}
